import React, { Fragment } from "react";
import { Link, withRouter } from "react-router-dom";
import Table from "react-bootstrap/Table";
import Popover from "react-bootstrap/Popover";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Button from "react-bootstrap/Button";
import Image from "react-bootstrap/Image";
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import moment from "moment";
import axios from "axios";
import { API_ROOT, API_HOST, API_ROOT1 } from "../utils/api-config";
import PhotoCameraIcon from "@material-ui/icons/PhotoCamera";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Tooltip from "@material-ui/core/Tooltip";
import { GoogleApiWrapper } from "google-maps-react";
import Filters from "./Filters";
let geocoder;
let token = "Bearer " + localStorage.getItem("token");
const config = {
  headers: {
    Authorization: token,
    "Content-Type": "application/json",
  },
};
class Deliveries extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      deliveries: [],
      delivery_id: "",
      order_number: "",
      merchant_id: "",
      active_confirm: false,
      active_route: false,
      find_by_number: false,
      routes: [],
      driverColor: [],
      places: [],
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleRouteChange = this.handleRouteChange.bind(this);
  }
  componentDidMount() {
    this.props;
    this.filterDeliveries();

    const activeRoutes = this.props.routes.filter((route) => !route.complete);
    this.setState({
      routes: activeRoutes,
      deliveries: this.props.deliveries,
    });
  }
  componentDidUpdate(prevProps) {
    if (this.props.routes != prevProps.routes) {
      const activeRoutes = this.props.routes.filter((route) => !route.complete);
      this.setState({
        routes: activeRoutes,
      });
    }
    if (this.props.deliveries != prevProps.deliveries) {
      this.filterDeliveries();
      this.setState({
        deliveries: this.props.deliveries,
      });
    }
  }

  handleFilter = (value) => {
    if (value === "all") {
      this.setState({
        deliveries: this.props.deliveries,
      });
    }
    if (value === "delivered") {
      const delivered = this.props.deliveries.filter((del) => del.delivered);
      this.setState({
        deliveries: delivered,
      });
    }
    if (value === "active") {
      const started = this.props.deliveries.filter(
        (del) => del.started && !del.delivered
      );
      this.setState({
        deliveries: started,
      });
    }
    if (value === "picked_up") {
      const picked_up = this.props.deliveries.filter(
        (del) => del.pick_up_time && !del.delivered
      );
      this.setState({
        deliveries: picked_up,
      });
    }
    if (value === "awaiting") {
      const awaiting = this.props.deliveries.filter((del) => !del.pick_up_time);
      this.setState({
        deliveries: awaiting,
      });
    }
    if (value === "routed") {
      const routed = this.props.deliveries.filter((del) => del.route_id);
      this.setState({
        deliveries: routed,
      });
    }
    if (value === "not_routed") {
      const notRouted = this.props.deliveries.filter((del) => !del.route_id);
      this.setState({
        deliveries: notRouted,
      });
    }
    if (value === "not_routed_pickup") {
      const notRoutedPickup = this.props.deliveries.filter(
        (del) => !del.pickup_route
      );
      this.setState({
        deliveries: notRoutedPickup,
      });
    }
    if (value === "failed") {
      const failed = this.props.deliveries.filter(
        (del) =>
          del.failed_at.length > 0 &&
          !del.route_id &&
          !del.delivered &&
          moment(del.failed_at[del.failed_at.length - 1]).format(
            "YYYY-MM-DD"
          ) === del.date &&
          !del.started
      );
      this.setState({
        deliveries: failed,
      });
    }
  };

  filterDeliveries() {
    this.setState({
      places: this.props.deliveries.filter((ful) => {
        return (
          ((ful.pickup && ful.shipfrom_latitude) ||
            (!ful.pickup && ful.shipto_latitude)) &&
          ful.name
        );
      }),
    });

    this.plotPoints();
  }
  plotPoints() {
    let locations = this.getPoints(geocoder);
    // console.log("locations", locations);

    Promise.all(locations).then((returnVals) => {
      returnVals.forEach((latLng) => {
        const fulId = this.props.deliveries.find(
          (place) => place.id == latLng[2]
        );

        if (fulId.pickup) {
          fulId.shipfrom_latitude = latLng[0];
          fulId.shipfrom_longitude = latLng[1];
        } else {
          fulId.shipto_latitude = latLng[0];
          fulId.shipto_longitude = latLng[1];
        }

        if (fulId.pickup) {
          this.getFromCoords(
            fulId.order_id,
            fulId.shipfrom_latitude,
            fulId.shipfrom_longitude
          );
        } else {
          this.getToCoords(
            fulId.order_id,
            fulId.shipto_latitude,
            fulId.shipto_longitude
          );
        }
      });
    });
  }

  getToCoords = (id, lat, long) => {
    const formData = new FormData();

    formData.append("order[id]", id);
    formData.append("order[shipto_latitude]", lat);
    formData.append("order[shipto_longitude]", long);
    axios
      .patch(`${API_ROOT}/orders/${id}`, formData, config)
      .then(({ data }) => console.log(data));
  };
  getFromCoords = (id, lat, long) => {
    const formData = new FormData();
    formData.append("order[id]", id);
    formData.append("order[shipfrom_latitude]", lat);
    formData.append("order[shipfrom_longitude]", long);
    axios
      .patch(`${API_ROOT}/orders/${id}`, formData, config)
      .then(({ data }) => console.log(data));
  };

  getAddressData() {
    let addressData = [];
    const filteredFulfillments = this.props.deliveries.filter((ful) => {
      return (
        (!ful.pickup && !ful.shipto_latitude) ||
        (ful.pickup && !ful.shipfrom_latitude)
      );
    });
    console.log(filteredFulfillments);

    for (let i = 0; i < filteredFulfillments.length; i++) {
      let location = filteredFulfillments[i].pickup
        ? `${
            filteredFulfillments[i].shipfrom_address1.includes("-")
              ? filteredFulfillments[i].shipfrom_address1.split("-")[1]
              : filteredFulfillments[i].shipfrom_address1
          } + ${filteredFulfillments[i].shipfrom_city}`
        : `${
            filteredFulfillments[i].shipto_address1.includes("-")
              ? filteredFulfillments[i].shipto_address1.split("-")[1]
              : filteredFulfillments[i].shipto_address1
          } + ${filteredFulfillments[i].shipto_city}`;
      addressData.push({ id: filteredFulfillments[i].id, location: location });
    }
    return addressData;
  }
  getPoints(geocoder) {
    let locationData = [];
    let addressData = this.getAddressData();
    for (let i = 0; i < addressData.length; i++) {
      // console.log("address", addressData);

      locationData.push(
        this.findLatLang(addressData[i].location, geocoder, addressData[i].id)
      );
    }
    return locationData; // array of promises
  }

  findLatLang(address, geocoder, id) {
    return new Promise(function (resolve, reject) {
      geocoder.geocode(
        {
          address: address,
        },
        function (results, status) {
          if (status === "OK") {
            console.log({ results });

            resolve([
              results[0].geometry.location.lat(),
              results[0].geometry.location.lng(),
              id,
            ]);
          } else {
            reject(
              alert(
                "Couldnt't find the location of " +
                  address +
                  ". Delivery id: " +
                  id
              )
            );
          }
        }
      );
    });
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;
    if (!/^[0-9]+$/.test(value)) {
      target.focus();
      return;
    } else
      this.setState({
        [name]: value,
        active_confirm: true,
      });
  }

  handleRouteChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value,
      active_route: true,
    });
  }

  findByNumber = () => {
    this.setState(() => ({
      find_by_number: !this.state.find_by_number,
    }));
  };

  handleSearchByNumber = () => {
    // console.log(this.state[id]);
    const formData = new FormData();
    let token = "Bearer " + localStorage.getItem("token");
    const config = {
      headers: {
        Authorization: token,
        "Content-Type": "application/json",
      },
    };
    formData.append("order_number", this.state.order_number);
    formData.append("merchant_id", this.state.merchant_id);
    axios
      .get(
        `${API_ROOT}/fulfillments/search?order_number=${this.state.order_number}&merchant_id=${this.state.merchant_id}`,
        config
      )
      .then((response) => {
        this.props.history.push(`/fulfillments/${response.data}`);
      });
  };

  handleEditRoute = (id) => {
    // console.log(this.state[id]);
    const formData = new FormData();
    let token = "Bearer " + localStorage.getItem("token");
    const config = {
      headers: {
        Authorization: token,
        "Content-Type": "application/x-www-form-urlencoded",
      },
    };
    formData.append("del_id", id);
    axios
      .put(`${API_ROOT}/routes/${this.state[id]}`, formData, config)
      .then((response) => {
        this.props.updateDeliveries();
      });
  };
  createOptions = () =>
    this.state.routes.map((data) => (
      <option key={data.id} value={data.id}>
        {data.id}
      </option>
    ));

  driverColor = (driverId) => {
    if (this.state.driverColor[driverId])
      return this.state.driverColor[driverId];
    else {
      let isWhite = true;
      while (isWhite && driverId) {
        const randomColor = Math.floor(Math.random() * 16777215).toString(16);
        try {
          const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(
            randomColor
          );
          isWhite =
            parseInt(result[1], 16) > 50 &&
            parseInt(result[2], 16) > 50 &&
            parseInt(result[3], 16) > 50
              ? true
              : false;
          if (!isWhite) {
            this.setState((prevState) => {
              return {
                driverColor: {
                  ...prevState.driverColor,
                  [driverId]: randomColor,
                },
              };
            });
          }
        } catch (e) {
          isWhite = undefined;
        }
      }
    }
  };
  render() {
    geocoder = new this.props.google.maps.Geocoder();
    const { deliveries } = this.state;

    const { drivers } = this.props;

    return (
      <div className="container-fluid">
        <style type="text/css">
          {`

    .table-colum {
      background-color: #D9F0FF; 
    }

    `}
        </style>
        <Toolbar style={{ justifyContent: "space-between" }}>
          <Typography variant="h6" id="tableTitle" component="div">
            {`${this.state.deliveries.length} Deliver${
              this.state.deliveries.length != 1 ? "ies" : "y"
            }`}
            <Typography variant="subtitle1" color="textSecondary">
              {`Total: ${this.props.deliveries.length}`}
            </Typography>
          </Typography>

          <div>
            {this.state.find_by_number ? (
              <Form className="form-inline" onSubmit={this.handleConfirm}>
                <Form.Row>
                  <Form.Group controlId="formDeliveryId">
                    <Button
                      className="ml-3"
                      variant="primary"
                      onClick={() => this.findByNumber()}
                    >
                      Find By Order Id
                    </Button>

                    <Form.Control
                      className="mx-sm-3"
                      name="order_number"
                      placeholder="Order Number"
                      onChange={this.handleInputChange}
                    />
                    <Form.Control
                      className="mx-sm-3"
                      name="merchant_id"
                      placeholder="Merchant Id"
                      onChange={this.handleInputChange}
                    />
                  </Form.Group>
                </Form.Row>
                <Button
                  className="ml-3"
                  variant="primary"
                  onClick={() => this.handleSearchByNumber()}
                >
                  Search
                </Button>
              </Form>
            ) : (
              <Form className="form-inline" onSubmit={this.handleConfirm}>
                <Form.Row>
                  <Form.Group controlId="formDeliveryId">
                    <Button
                      className="ml-3"
                      variant="primary"
                      onClick={() => this.findByNumber()}
                    >
                      Find By Order Number
                    </Button>
                    <Form.Control
                      className="mx-sm-3"
                      name="delivery_id"
                      placeholder="Enter Order Id"
                      onChange={this.handleInputChange}
                    />
                  </Form.Group>
                </Form.Row>
                <Link to={`/fulfillments/${this.state.delivery_id}`}>
                  <Button
                    className="ml-3"
                    variant="primary"
                    disabled={!this.state.active_confirm}
                  >
                    Search
                  </Button>
                </Link>
              </Form>
            )}
          </div>
          <Tooltip title="Filter deliveries">
            <Filters filterDeliveries={this.handleFilter} />
          </Tooltip>
        </Toolbar>
        <br></br>
        <Table striped bordered hover responsive>
          <thead>
            <tr className="table-primary">
              <th>ID</th>
              <th>Timeslot</th>
              <th>Order</th>
              <th>Bags</th>
              <th>Price</th>
              <th>Neighborhood</th>
              <th>Type</th>
              <th>Status</th>
              <th>Pickup Route</th>
              <th>Delivery Route</th>
              <th>Driver</th>
            </tr>
          </thead>
          <tbody>
            {deliveries.map((item, i) => {
              const driverColor = this.driverColor(deliveries[i].driver_id);
              const driver = drivers.find(
                (driv) => driv.id == deliveries[i].driver_id
              );
              const pickup_driver = drivers.find(
                (driv) => driv.id == deliveries[i].pickup_driver
              );
              const transit = drivers.find(
                (driv) => driv.id === deliveries[i].transit_with
              );
              const renderElement = () => {
                if (
                  deliveries[i].failed_at.length > 0 &&
                  !deliveries[i].route_id &&
                  !deliveries[i].delivered &&
                  moment(
                    deliveries[i].failed_at[deliveries[i].failed_at.length - 1]
                  ).format("YYYY-MM-DD") === deliveries[i].date &&
                  !deliveries[i].started
                )
                  return (
                    <OverlayTrigger
                      trigger={["hover", "focus"]}
                      placement="right"
                      overlay={
                        <Popover>
                          <span className="badge badge-danger">
                            {deliveries[i].failed_notes.toString()}
                          </span>
                        </Popover>
                      }
                    >
                      <span className="badge badge-pill  badge-danger">
                        Failed
                      </span>
                    </OverlayTrigger>
                  );
                else if (
                  !deliveries[i].pick_up_time &&
                  !deliveries[i].entered_dc_at &&
                  !deliveries[i].delivered &&
                  !deliveries[i].transit
                )
                  return (
                    <span className="badge badge-pill  badge-warning">
                      Awaiting Pickup
                      {/* {deliveries[i].pickup
                        ? "With customer"
                        : "In store"} */}
                    </span>
                  );
                else if (deliveries[i].transit)
                  return (
                    <span className="badge badge-pill  badge-info">
                      In car with {transit && transit.first_name}
                    </span>
                  );
                else if (
                  deliveries[i].entered_dc_at &&
                  !deliveries[i].delivered
                )
                  return (
                    <span className="badge badge-pill  badge-primary">
                      In DC
                    </span>
                  );
                // else if (
                //   !deliveries[i].entered_dc_at &&
                //   deliveries[i].transit === "Routed with"
                // )
                //   return (
                //     <span className="badge badge-pill  badge-info">
                //       Scheduled with {transit && transit.first_name}
                //     </span>
                //   );
                // else if (
                //   deliveries[i].pick_up_time &&
                //   !deliveries[i].delivered
                // )
                //   return (
                //     <span className="badge badge-pill  badge-info">
                //       Picked Up
                //     </span>
                //   );
                else if (deliveries[i].delivered)
                  return (
                    <span className="badge badge-pill  badge-success">
                      Delivered
                    </span>
                  );

                return null;
              };
              const tableStyle = () => {
                if (
                  deliveries[i].booking_id % 2 == 0 &&
                  deliveries[i].booking_index % 2 == 0
                )
                  return "badge badge-info";
                else if (
                  deliveries[i].booking_id % 2 != 0 &&
                  deliveries[i].booking_index % 2 != 0
                )
                  return "badge badge-success";
                else if (
                  deliveries[i].booking_id % 2 == 0 &&
                  deliveries[i].booking_index % 2 != 0
                )
                  return "badge badge-warning";
                else if (
                  deliveries[i].booking_id % 2 != 0 &&
                  deliveries[i].booking_index % 2 == 0
                )
                  return "badge badge-primary";

                return null;
              };

              return (
                <tr key={deliveries[i].id} className="table-colum">
                  <td>
                    <Link to={`/fulfillments/${deliveries[i].order_id}`}>
                      {deliveries[i].order_id}
                    </Link>
                  </td>
                  <td>
                    {deliveries[i].delivery_window || ""}{" "}
                    <span className={tableStyle()}>
                      {deliveries[i].booking_index}
                    </span>
                    <br></br>
                    <Link to={`/rescheduleDelivery/${deliveries[i].id}`}>
                      <span className="badge badge-pill badge-roman">
                        Reschedule
                      </span>
                    </Link>
                  </td>
                  <td className={"badge-link"}>
                    <a
                      href={`${API_ROOT1}/deliverydetails?id=${deliveries[i].id}&adminview=true`}
                    >
                      {deliveries[i].name} - {deliveries[i].order_number}
                    </a>
                    <span>
                      {deliveries[i].pickup
                        ? deliveries[i].shipfrom_name
                        : deliveries[i].shipto_first_name +
                          " " +
                          deliveries[i].shipto_last_name}
                    </span>
                  </td>
                  <td>{deliveries[i].number_of_bags}</td>
                  <td>${deliveries[i].price / 100}</td>
                  <td>{deliveries[i].neighborhood || ""}</td>
                  <td>
                    {deliveries[i].pickup ? (
                      <span className="badge badge-pill  badge-dark">R</span>
                    ) : (
                      <span className="badge badge-pill  badge-light">D</span>
                    )}{" "}
                    {deliveries[i].downtown_toronto_zone ? (
                      <span className="badge badge-pill  badge-light">I</span>
                    ) : (
                      <span className="badge badge-pill  badge-dark">O</span>
                    )}{" "}
                    {deliveries[i].exchange && (
                      <span className="badge badge-pill  badge-danger">E</span>
                    )}
                  </td>
                  <td>
                    {deliveries[i].started && deliveries[i].route_id ? (
                      <a
                        href={`${API_HOST}/loc?t=${deliveries[i].task}&r=${deliveries[i].order_number}`}
                        target="_blank"
                      >
                        {deliveries[i].pickup && deliveries[i].pick_up_time ? (
                          deliveries[i].delivered ? (
                            <span className="badge badge-pill  badge-success">
                              Returned
                            </span>
                          ) : (
                            <span className="badge badge-pill  badge-info">
                              In car with {driver && driver.first_name}
                            </span>
                          )
                        ) : deliveries[i].delivered ? (
                          <OverlayTrigger
                            trigger={["hover", "focus"]}
                            placement="left"
                            overlay={
                              <Popover>
                                <Image
                                  thumbnail
                                  src={deliveries[i].customer_signature}
                                />
                              </Popover>
                            }
                          >
                            <span className="badge badge-pill  badge-success">
                              Delivered
                              {deliveries[i].customer_signature && (
                                <PhotoCameraIcon />
                              )}
                            </span>
                          </OverlayTrigger>
                        ) : (
                          <span className="badge badge-pill  badge-secondary">
                            Started
                          </span>
                        )}
                      </a>
                    ) : (
                      renderElement()
                    )}
                    {item.order_notes
                      ? item.order_notes.map((note) => <li>{note}</li>)
                      : ""}
                  </td>
                  <td>
                    {deliveries[i].pickup_route ? (
                      <div>
                        {deliveries[i].pickup_route} <br></br>
                        <span className="badge badge-pill  badge-secondary">
                          {pickup_driver && pickup_driver.first_name}
                        </span>
                      </div>
                    ) : deliveries[i].entered_dc_at ? (
                      ""
                    ) : (
                      <span className="badge badge-pill  badge-danger">
                        {
                          deliveries[i].store_hours[
                            moment(deliveries[i].date).format("e")
                          ]["Close"]
                        }
                        :00
                      </span>
                    )}
                  </td>
                  <td>
                    {deliveries[i].route_id ? (
                      <Link to={`/routes/${deliveries[i].route_id}`}>
                        <span className={"badge-roman"}>
                          {deliveries[i].route_id || ""}
                        </span>
                      </Link>
                    ) : deliveries[i].delivered ? (
                      ""
                    ) : (
                      <Form.Group
                        as={Col}
                        className="table-primary"
                        controlId="formGridRoute"
                      >
                        <Form.Control
                          className="bg-light"
                          name={deliveries[i].id}
                          onChange={this.handleRouteChange}
                          as="select"
                        >
                          <option>Add to Route</option>
                          {this.createOptions()}
                        </Form.Control>
                      </Form.Group>
                    )}
                  </td>
                  <td>
                    {deliveries[i].driver_id ? (
                      <span
                        style={{
                          color: `#${driverColor}`,
                        }}
                      >
                        {driver ? driver.first_name : deliveries[i].driver_id}
                      </span>
                    ) : (
                      <Fragment>
                        {this.state[deliveries[i].id] && (
                          <Button
                            variant="outline-primary"
                            disabled={!this.state.active_route}
                            onClick={() =>
                              this.handleEditRoute(deliveries[i].id)
                            }
                          >
                            Edit Route
                          </Button>
                        )}
                      </Fragment>
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>
    );
  }
}

export default GoogleApiWrapper({
  apiKey: "AIzaSyCgImsLUsK-v_7T9gytx9fmfHyYL4HDnSQ",
})(withRouter(Deliveries));
